import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NewCredentialsDisplay } from "../components/new-credentials-display";

interface CredentialsState {
  username: string;
  password: string;
  firstName?: string;
  lastName?: string;
  ownCredentials?: boolean;
  redirectUrl?: string;
}

export function CredentialsRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  const state = (location.state as CredentialsState) || {};
  const {
    username,
    password,
    firstName,
    lastName,
    ownCredentials = false,
    redirectUrl = null,
  } = state;

  useEffect(() => {
    if (!username || !password) {
      navigate("/dashboard/users", { replace: true });
    }
  }, [username, password, navigate]);

  const handleBack = () => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <NewCredentialsDisplay
        firstName={firstName}
        lastName={lastName}
        username={username}
        password={password}
        onBack={handleBack}
        className="mx-auto"
        ownCredentials={ownCredentials}
      />
    </div>
  );
}
